import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { okeiApi } from '../../lib/api';
import type { Okei } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/okei/';

export default (props: PageProps) => {
  const [data, setData] = useState<Partial<Okei>>({ id: props.id });

  const breadCrumbs = [
    { to: '/', name: 'Главная' },
    { name: 'Справочники' },
    { to: `${entryPointPath}`, name: 'ОКЕИ' },
    ...(data.id
      ? [
          { to: `${entryPointPath}${data.id}`, name: data.id.toString() },
          { name: 'Редактирование' }
        ]
      : [{ name: 'Новая запись' }])
  ];

  const onFetch = useCallback(async () => {
    !!props.id && setData(await okeiApi.get(props.id, {}));
  }, [props.id]);

  const onSubmit = async (payload: Okei) => {
    let id = payload.id;
    if (id) {
      await okeiApi.update(payload);
    } else {
      let data = await okeiApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: Okei) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'ОКЕИ'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
